document.addEventListener("DOMContentLoaded", function () {
  const countdownWrappers = document.querySelectorAll("[data-enhanced-countdown]");
  const sameDayHeader = document.querySelector("[data-same-day-header]");
  const printDateDisplay = document.querySelector("[data-print-date-display]");
  const printDateValue = document.querySelector("[data-print-date-value]");
  const sameDayDateDisplay = document.querySelector("[data-same-day-date-display]");
  const sameDayDateValue = document.querySelector("[data-same-day-date-value]");

  countdownWrappers.forEach((container) => {
    const productionDays = JSON.parse(container.dataset.productionDays || "[]");
    const blackoutDates = JSON.parse(container.dataset.blackoutDates || "[]");
    const cutoffTime = container.dataset.cutoffTime || "11:00";
    const separator = container.dataset.separator || ":";
    const deliveryOptions = JSON.parse(container.dataset.deliveryOptions || "[]");
    const showDeliveryOptions = container.dataset.showDeliveryOptions === "true";

    const countdownEl = container.querySelector("[data-countdown]");
    const endMessageEl = container.querySelector("[data-end-message]");

    // Current selected delivery option
    let selectedDeliveryOption = deliveryOptions[0] || "same_day";
    let selectedDays = 0;

    // Initialize delivery option buttons
    const deliveryOptionButtons = document.querySelectorAll("[data-delivery-option]");
    
    // Helper function to get days from delivery option name
    function getDaysFromOption(option) {
      switch(option) {
        case 'same_day': return 0;
        case '2_days': return 2;
        case '3_days': return 3;
        case '4_days': return 4;
        case '5_days': return 5;
        default: return 0;
      }
    }
    
    // Set initial selectedDays based on first delivery option
    selectedDays = getDaysFromOption(selectedDeliveryOption);
    console.log('Initial setup:', { selectedDeliveryOption, selectedDays });

    deliveryOptionButtons.forEach((btn, index) => {
      btn.addEventListener("click", function() {
        // Remove active class from all buttons
        deliveryOptionButtons.forEach(b => b.classList.remove("active"));
        
        // Add active class to clicked button
        this.classList.add("active");
        
        // Update selected option
        selectedDeliveryOption = this.dataset.deliveryOption;
        selectedDays = parseInt(this.dataset.days);
        
        console.log('Button clicked:', { selectedDeliveryOption, selectedDays });
        
        // Update header text for multi-day options
        updateHeaderText();
        
        // Update display immediately
        updateDisplay();
      });

      // Set first option as active by default
      if (index === 0) {
        btn.classList.add("active");
        selectedDeliveryOption = btn.dataset.deliveryOption;
        selectedDays = parseInt(btn.dataset.days);
        console.log('First button set active:', { selectedDeliveryOption, selectedDays });
      }
    });

    /**
     * Update header text based on selected delivery option
     */
    function updateHeaderText() {
      if (!sameDayHeader) return;
      
      const headerSameDayTemplate = sameDayHeader.dataset.headerSameDay || "Order by {cutoff} for Same Day Printing!";
      const headerMultiDayTemplate = sameDayHeader.dataset.headerMultiDay || "Order by {cutoff} to ship within {days} production days!";
      
      let headerText;
      if (selectedDeliveryOption === "same_day") {
        headerText = headerSameDayTemplate;
      } else {
        headerText = headerMultiDayTemplate.replace('{days}', selectedDays);
      }
      
      // Replace {cutoff} placeholder with actual cutoff time
      const cutoffTime12h = formatCutoffTime(cutoffTime);
      headerText = headerText.replace('{cutoff}', cutoffTime12h);
      
      sameDayHeader.innerHTML = headerText;
    }

    /**
     * Format cutoff time from 24h to 12h format
     */
    function formatCutoffTime(time24h) {
      const [hour, minute] = time24h.split(':');
      const hour12 = hour % 12 || 12;
      const ampm = hour < 12 ? 'AM' : 'PM';
      return `${hour12}:${minute} ${ampm}`;
    }

    /**
     * Get current New York time
     */
    function getNewYorkDate() {
      const now = new Date();
      const options = {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };

      const formatter = new Intl.DateTimeFormat("en-US", options);
      const parts = formatter.formatToParts(now);
      const dateParts = {};

      parts.forEach(({ type, value }) => {
        dateParts[type] = value;
      });

      return new Date(
        `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}`
      );
    }

    /**
     * Get day name for a date in NY timezone
     */
    function getNewYorkDayName(date) {
      return new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        timeZone: "America/New_York",
      }).format(date);
    }

    /**
     * Format date as "Monday, August 18th"
     */
    function formatDeliveryDate(date) {
      return new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
        timeZone: "America/New_York",
      }).format(date);
    }

    /**
     * Check if date is a blackout date
     */
    function isBlackoutDate(date) {
      const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD format
      return blackoutDates.includes(dateStr);
    }

    /**
     * Check if date is a production day
     */
    function isProductionDay(date) {
      const dayName = getNewYorkDayName(date);
      return productionDays.includes(dayName) && !isBlackoutDate(date);
    }

    /**
     * Get cutoff time for a specific date
     */
    function getCutoffTimeFor(date) {
      const [hour, minute] = cutoffTime.split(":").map(Number);
      const cutoff = new Date(date);
      cutoff.setHours(hour, minute, 0, 0);
      return cutoff;
    }

    /**
     * Find next production day from a given date
     */
    function getNextProductionDay(startDate) {
      for (let offset = 1; offset <= 14; offset++) { // Check up to 2 weeks ahead
        const nextDate = new Date(startDate);
        nextDate.setDate(startDate.getDate() + offset);
        
        if (isProductionDay(nextDate)) {
          return {
            date: nextDate,
            label: getNewYorkDayName(nextDate)
          };
        }
      }
      return null;
    }

    /**
     * Calculate print date for multi-day orders
     */
    function calculatePrintDate(now) {
      const isTodayProduction = isProductionDay(now);
      const todayCutoff = getCutoffTimeFor(now);
      const beforeCutoff = now < todayCutoff;
      
      let startCountingFrom;
      
      if (isTodayProduction && beforeCutoff) {
        // Order placed before cutoff on production day
        // Processing starts TODAY
        startCountingFrom = now;
      } else {
        // Order placed after cutoff OR on non-production day
        // Processing starts NEXT production day
        const nextProd = getNextProductionDay(now);
        if (!nextProd) return null;
        
        // SIMPLIFIED: Just use the next production date directly
        startCountingFrom = nextProd.date;
      }
      
      if (!startCountingFrom) return null;
      
      // Count the specified number of production days INCLUDING the start counting date
      // The processing start day DOES count as day 1
      let daysCount = 0;
      let currentDate = new Date(startCountingFrom);
      
      // Start from the processing start date itself (offset = 0)
      for (let offset = 0; offset <= 30; offset++) {
        currentDate = new Date(startCountingFrom);
        currentDate.setDate(startCountingFrom.getDate() + offset);
        
        if (isProductionDay(currentDate)) {
          daysCount++;
          
          if (daysCount >= selectedDays) {
            return {
              printDate: currentDate,
              message: formatDeliveryDate(currentDate)
            };
          }
        }
      }
      
      return null;
    }
    
    /**
     * Get same day countdown info
     */
    function getSameDayInfo(now) {
      const isTodayProduction = isProductionDay(now);
      const todayCutoff = getCutoffTimeFor(now);
      const beforeCutoff = now < todayCutoff;
      
      if (isTodayProduction && beforeCutoff) {
        return {
          targetTime: todayCutoff,
          showCountdown: true
        };
      } else {
        // Find next production day for same day
        const nextProd = getNextProductionDay(now);
        if (nextProd) {
          return {
            targetTime: getCutoffTimeFor(nextProd.date),
            showCountdown: true
          };
        }
      }
      
      return { showCountdown: false };
    }

    /**
     * Format countdown unit (original style)
     */
    function formatUnit(num, label) {
      const padded = num.toString().padStart(2, "0");
      return `
        <div class="unit">
          <div class="num">${padded}</div>
          <div class="label">${label}</div>
        </div>
      `;
    }

    /**
     * Main display update function
     */
    function updateDisplay() {
      const now = getNewYorkDate();
      
      // Hide all elements initially
      if (sameDayHeader) sameDayHeader.style.display = "none";
      if (printDateDisplay) printDateDisplay.style.display = "none";
      if (sameDayDateDisplay) sameDayDateDisplay.style.display = "none";
      if (countdownEl) countdownEl.style.display = "none";
      if (endMessageEl) endMessageEl.style.display = "none";
      
      if (selectedDeliveryOption === "same_day") {
        // Same day logic - show header and countdown, or next production day
        const isTodayProduction = isProductionDay(now);
        const todayCutoff = getCutoffTimeFor(now);
        const beforeCutoff = now < todayCutoff;
        
        if (isTodayProduction && beforeCutoff) {
          // Show countdown until cutoff for same day
          if (sameDayHeader) sameDayHeader.style.display = "block";
          updateSameDayCountdown(now, todayCutoff);
        } else {
          // After cutoff or non-production day - show next production day
          const nextProd = getNextProductionDay(now);
          if (nextProd && sameDayDateDisplay && sameDayDateValue) {
            sameDayDateValue.innerHTML = formatDeliveryDate(nextProd.date);
            sameDayDateDisplay.style.display = "block";
          } else {
            // Fallback to end message if no next production day found
            if (endMessageEl) endMessageEl.style.display = "block";
          }
        }
      } else {
        // Multi-day logic - show countdown until cutoff, then show delivery date
        const isTodayProduction = isProductionDay(now);
        const todayCutoff = getCutoffTimeFor(now);
        const beforeCutoff = now < todayCutoff;
        
        if (isTodayProduction && beforeCutoff) {
          // Show countdown until cutoff for multi-day orders
          if (sameDayHeader) sameDayHeader.style.display = "block";
          updateMultiDayCountdown(now, todayCutoff);
        } else {
          // Show delivery date (processing starts next production day)
          const printInfo = calculatePrintDate(now);
          
          if (printInfo && printDateDisplay && printDateValue) {
            printDateValue.innerHTML = printInfo.message;
            printDateDisplay.style.display = "block";
          } else {
            if (endMessageEl) endMessageEl.style.display = "block";
          }
        }
      }
    }
    
    /**
     * Update same day countdown (original style)
     */
    function updateSameDayCountdown(now, targetTime) {
      const diff = targetTime - now;
      const totalSeconds = Math.floor(diff / 1000);
      
      if (totalSeconds <= 0) {
        // Cutoff reached, switch to showing next production day
        updateDisplay();
        return;
      }
      
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      const parts = [];
      if (days > 0) {
        parts.push(formatUnit(days, "Days"));
        parts.push(`<div class="sep">${separator}</div>`);
      }
      parts.push(formatUnit(hours, "Hours"));
      parts.push(`<div class="sep">${separator}</div>`);
      parts.push(formatUnit(minutes, "Minutes"));
      parts.push(`<div class="sep">${separator}</div>`);
      parts.push(formatUnit(seconds, "Seconds"));
      
      if (countdownEl) {
        countdownEl.innerHTML = parts.join("");
        countdownEl.style.display = "flex";
      }
    }

    /**
     * Update multi-day countdown (shows countdown until cutoff)
     */
    function updateMultiDayCountdown(now, targetTime) {
      const diff = targetTime - now;
      const totalSeconds = Math.floor(diff / 1000);
      
      if (totalSeconds <= 0) {
        // After cutoff, switch to showing delivery date
        updateDisplay();
        return;
      }
      
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      const parts = [];
      if (days > 0) {
        parts.push(formatUnit(days, "Days"));
        parts.push(`<div class="sep">${separator}</div>`);
      }
      parts.push(formatUnit(hours, "Hours"));
      parts.push(`<div class="sep">${separator}</div>`);
      parts.push(formatUnit(minutes, "Minutes"));
      parts.push(`<div class="sep">${separator}</div>`);
      parts.push(formatUnit(seconds, "Seconds"));
      
      if (countdownEl) {
        countdownEl.innerHTML = parts.join("");
        countdownEl.style.display = "flex";
      }
    }

    // Initial setup
    updateHeaderText();
    updateDisplay();
    setInterval(updateDisplay, 1000);
  });
});
